/*
 * Contents Page Views
 */

define(["marionette", "modules/contentsSplit/contents/template/contentsTemplate.html"], function (
  Marionette,
  ContentsTemplate,
) {
  var ContentsView = {};

  ContentsView.contentsLayout = Marionette.Layout.extend({
    template: ContentsTemplate,
    regions: {
      contentsTree: "#contentsTree",
      contentsList: "#contentsList",
      contentsSearch: "#contentsSearch",
    },
    triggers: {
      "click #addContent": "add:content",
    },
    showSearchPane: function () {
      //show the last tab
      this.$el.find("#contentsSearchTab").tab("show");
    },
  });

  return ContentsView;
});
